import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { logError } from './error';
import classes from './LoginErrorPage.module.css';

const LoginErrorPage = ({ }) => {

    const { applictionName } = useParams();
    const { texts } = useSelector(state => state.translate);
    const uiData = useSelector((state) => state.general.uiData);
    const [content, setContent] = useState(null);

    useEffect(() => {
        // let tryToFixBegin = localStorage.getItem("trytofixbegin");
        // if (!tryToFixBegin) {
        //     logError("try to fix login", "try to fix login", "LOGIN")
        //     let i = 6 ; 
        //     const timerInterval = setInterval(() => {
        //         if (i == 0) {
        //             clearInterval(timerInterval);
        //             localStorage.setItem("trytofixbegin", true);
        //             window.location.href = `${window.config.identityURL}/api/auth/logout?next=${window.location.origin}/${applictionName}`
        //             // window.location.href=`${window.config.identityURL}/api/auth/idm?next=${window.location.origin}/${applictionName}&nextError=${window.location.origin}/${applictionName}/error`
        //         }
        //         else {
        //             i=i-1;
        //             setContent(`אירעה תקלה מחברים אותך מחדש ${i}` );
        //         }

        //     }, 1000)
        // }
        // else {
        //     localStorage.removeItem("trytofixbegin");
        //     logError("try to fix login faild","try to fix login faild","LOGIN")
        //     setContent("ארעה תקלה נסה שוב מאוחר יותר");
        // }
    }, [])
    return <>
        {uiData && <div className={classes.LoginErrorPage} style={{ backgroundImage: `url(${uiData?.loginErrBg})` }}>
            <div className={classes.Container}>
                <div>
                    <div className={classes.ErrorMsgTitle}>{texts.weDontRecognizeYou}</div>
                    <div className={classes.ErrorMsgContent}>{texts.pleaseCloseThePage}</div>
                </div>
                <img className={classes.Img} src={window.config?.[applictionName]?.studentImg} alt={applictionName} />
            </div>
            <div className={classes.ContainerIcon} style={{ backgroundImage: `url(${uiData?.loginErrIcon})` }}></div>
        </div>}
    </>
}

export default LoginErrorPage;